import { FlagProvider } from '@unleash/proxy-client-react';
import config from 'config';
import 'integrations/sentry';
import { history } from 'lib/history';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import DialpadChat from 'components/Dialpad';
import './i18n';

import configureStore from './redux/configureStore';
import initTracking from 'lib/tracking';

const unleashConfig = {
  url: config.unleash.url,
  clientKey: config.unleash.clientKey,
  appName: config.unleash.appName,
  environment: config.unleash.environment,
};

const initialize = async () => {
  const store = await configureStore({}, history);
  const { Router } = await import('./routes');

  initTracking(
    window,
    document,
    config.gainSightTracking.url,
    config.gainSightTracking.clientKey
  );

  render(
    <Provider store={store}>
      <FlagProvider config={unleashConfig}>
        <Router history={history} store={store} />
      </FlagProvider>
      <DialpadChat />
    </Provider>,
    document.getElementById('root')
  );
};

if (
  ['complete', 'loaded', 'interactive'].includes(document.readyState) &&
  document.body
) {
  initialize();
} else {
  document.addEventListener('DOMContentLoaded', () => initialize(), false);
}

if (__DEVELOPMENT__) {
  window.React = React;
}
